/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IHeiSailthruSignupFormData } from './hei-sailthru-signup-form.data';
import { IHeiSailthruSignupFormProps } from './hei-sailthru-signup-form.props.autogenerated';

export interface IHeiSailthruSignupFormViewProps extends IHeiSailthruSignupFormProps<IHeiSailthruSignupFormData> {}

/**
 *
 * HeiSailthruSignupForm component
 * @extends {React.PureComponent<IHeiSailthruSignupFormProps<IHeiSailthruSignupFormData>>}
 */
class HeiSailthruSignupForm extends React.PureComponent<IHeiSailthruSignupFormProps<IHeiSailthruSignupFormData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default HeiSailthruSignupForm;
